import React from "react";
import { ArrowUpRight, Sparkles } from "lucide-react";

const COMPACT_COPY =
  "Gut health drives energy, focus, and metabolism — ask about adding Digestive & Microbiome Optimization.";

export function GutCrossSellBand({ compact = false }) {
  if (compact) {
    return (
      <section className="border-y border-[color:var(--iw-border)] bg-[color:var(--iw-bg)] py-8">
        <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-4 px-5 sm:flex-row sm:items-center sm:px-8">
          <div className="flex items-start gap-3">
            <span className="mt-0.5 inline-grid h-9 w-9 flex-shrink-0 place-items-center border border-[color:var(--iw-blue)]/60 text-[color:var(--iw-blue)]">
              <Sparkles className="h-4 w-4" />
            </span>
            <p className="text-base leading-relaxed text-[color:var(--iw-primary)] sm:text-lg">
              {COMPACT_COPY}
            </p>
          </div>
          <a
            href="/digestive"
            className="iw-btn-ghost inline-flex flex-shrink-0 items-center gap-2 px-5 py-3 font-mono text-[10px] uppercase tracking-[0.22em]"
          >
            See Digestive · GI.03 <ArrowUpRight className="h-3.5 w-3.5" />
          </a>
        </div>
      </section>
    );
  }

  return (
    <section className="border-b border-[color:var(--iw-border)] bg-[color:var(--iw-primary)] py-16 text-white">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-8 px-5 sm:px-8 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-8">
          <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-[color:var(--iw-accent-red)]">
            GI.03 · Cross-sell
          </div>
          <h3 className="mt-3 font-display text-3xl font-semibold tracking-tight sm:text-4xl">
            {COMPACT_COPY}
          </h3>
        </div>
        <div className="flex items-end lg:col-span-4 lg:justify-end">
          <a
            href="/digestive"
            className="iw-btn-red inline-flex items-center gap-2 px-7 py-4 font-mono text-[11px] uppercase tracking-[0.22em]"
          >
            Explore Digestive Optimization <ArrowUpRight className="h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  );
}

export default GutCrossSellBand;
